export default "__VITE_ASSET__DtBcSREE__"